import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-stats-empty',
  templateUrl: './stats-empty.component.html',
  styleUrls: ['./stats-empty.component.scss'],
  standalone: true,
  imports: [MatIconModule, TranslateModule],
})
export class StatsEmptyComponent {}
